/**
 * Creates API endpoint with path parameters
 * @param {string} baseEndpoint - Base API endpoint
 * @param {Object} params - Object with path parameters
 * @returns {string} Formatted endpoint with parameters
 */
export const createEndpoint = (baseEndpoint, params = {}) => {
  let endpoint = baseEndpoint;

  // Replace path parameters in endpoint
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      endpoint = endpoint.replace(`:${key}`, value);
    }
  });

  return endpoint;
};

/**
 * Creates query string from object
 * @param {Object} queryParams - Object with query parameters
 * @returns {string} Formatted query string
 */
export const createQueryString = (queryParams = {}) => {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      // Always convert value to string to avoid URLSearchParams issues
      params.append(key, String(value));
    }
  });

  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};

/**
 * Generate a full API request function with error handling
 * @param {Function} apiCall - The axios call function
 * @returns {Function} Wrapped function with error handling
 */
export const createApiRequest = apiCall => {
  return async (...args) => {
    // Simply call and return the data property
    // No try/catch here - we let the error propagate naturally
    // The error is already handled by the interceptor
    const response = await apiCall(...args);
    return response.data;
  };
};

/**
 * Create a collection of API methods with error handling
 * @param {Object} apiMethods - Object with API methods
 * @returns {Object} Object with wrapped API methods
 */
export const createApiModule = apiMethods => {
  return Object.entries(apiMethods).reduce(
    (acc, [key, method]) => ({
      ...acc,
      [key]: createApiRequest(method)
    }),
    {}
  );
};
